import { useTranslation } from 'react-i18next';
import { useScheduleContext } from '@/pages/Schedule/contexts';
import { Button, forwardRef, Text } from '@/ui';
import { isPollSchedule } from '@/utils/schedule';
import { Confetti } from './Confetti';
import { StateCard, type StateCardProps } from './StateCard';

type Props = StateCardProps & {
  onClose: () => void;
  onReset: () => void;
};

export const SuccessState = forwardRef(
  ({ onClose, onReset, ...props }: Props, ref) => {
    const { t } = useTranslation('addContent', { keyPrefix: 'success_state' });
    const { schedule } = useScheduleContext();
    const isPoll = Boolean(schedule && isPollSchedule(schedule));

    return (
      <StateCard ref={ref} {...props}>
        <Confetti mx="auto" />

        <Text fontSize="48px" lineHeight="1">
          🎉
        </Text>
        <Text fontSize="lg" fontWeight="bold">
          {isPoll ? t('title_form') : t('title')}
        </Text>
        <Button colorScheme="dark" onClick={onClose}>
          {isPoll ? t('close_form') : t('close')}
        </Button>
        <Text>
          {t('or')}{' '}
          <Button
            colorScheme="dark"
            fontSize="md"
            textDecor="underline"
            variant="link"
            onClick={onReset}
          >
            {t('add_more')}
          </Button>
        </Text>
      </StateCard>
    );
  }
);
